import React, { Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../../Services/translation';
import PanelBeamCuttingSvgAlt from './PanelBeamCuttingSvgAlt';
import { setCuttingDetails } from '../../Actions/Configurator.action';

const PanelBeam = ({ id, currentCutType }) => {
  const [selectedBeamType, setSelectedBeamType] = useState(1);
  const configurator = useSelector((state) => state.configurator);
  const { erpVariantId, rules, selections } = configurator;

  let cuttingDetail = selections.cuttingDetails.find((x) => x.id == id);
  const dispatch = useDispatch();
  const [cutType, setCutType] = useState(cuttingDetail.cutType || {});

  const setTab = (type) => {
    setCutType({});
    //change('cutCode', null);
    setSelectedBeamType(type);
  };

  const getCutDescription = () => {
    let description = translate('panelbeam.description.cutcode') + cutType.cutCode;

    if (cutType.cutAngleA) {
      description += ', ' + translate('panelbeam.description.cutanglea') + cutType.cutAngleA + translate('panelbeam.description.delimiter');
    }

    if (cutType.cutAngleB) {
      description += ', ' + translate('panelbeam.description.cutangleb') + cutType.cutAngleB + translate('panelbeam.description.delimiter');
    }

    return description;
  };

  const change = (property, value) => {
    cutType[property] = value;
    setCutType(cutType);

    if (isCutValid()) {
      cutType.description = getCutDescription();
      dispatch(setCuttingDetails(id, 'cutType', cutType));
    }
  };

  const isCutValid = () => {
    if (!cutType || !cutType.cutCode) return false;

    let rule = rules.cutTypes.find((c) => c.code === cutType.cutCode);

    if (!rule) {
      console.error('could not find cut rules for code: ' + cutType.cutCode);
      return false;
    }

    if (rule.maxAngleA > -1 && !cutType.cutAngleA) {
      return false;
    }

    if (rule.maxAngleB > -1 && !cutType.cutAngleB) {
      return false;
    }

    return true;
  };

  const getAllAnglesItems = () => {
    let selectedBeam = selectedBeamType;
    let selectedBeamText = 'straight';
    if (selectedBeam === 1) {
      selectedBeamText = 'straight';
    } else if (selectedBeam === 0) {
      selectedBeamText = 'oneSide';
    } else if (selectedBeam === 2) {
      selectedBeamText = 'twoSides';
    }
    if (selectedBeam === -1) {
      selectedBeam = 1;
    }
    return rules.cutTypes.filter(
      (c) => c.type === selectedBeam || c.type === selectedBeamText
    );
  };

  return (
    <Fragment>
      <div className='accordion-panel__panel_header'></div>
      <svg style={{ display: 'none' }}>
        <symbol id='cut-selection-f' viewBox='0 0 360 120'>
          {/* Symbol contents */}
        </symbol>
        <symbol id='cut-selection-b' viewBox='0 0 360 120'>
          {/* Symbol contents */}
        </symbol>
        <symbol id='cut-bg' viewBox='0 0 1200 400'>
          <line
            x1='10'
            y1='50'
            x2='10'
            y2='390'
            stroke='currentColor'
            strokeDasharray='20'
            strokeDashoffset='30'
            strokeWidth='5'
          />
          <path d='M10 50 l40 20 l0 -40Z' fill='currentColor' />
          <line
            x1='20'
            y1='50'
            x2='1180'
            y2='50'
            stroke='currentColor'
            strokeWidth='5'
          />
          <path d='M1190 50 l-40 20 l0 -40Z' fill='currentColor' />
          <text
            textAnchor='middle'
            fill='currentColor'
            className='svg-text'
            x='600'
            y='110'
          >
            L
          </text>
          <line
            x1='1190'
            y1='50'
            x2='1190'
            y2='390'
            stroke='currentColor'
            strokeDasharray='20'
            strokeDashoffset='30'
            strokeWidth='5'
          />
        </symbol>
      </svg>
      <div className='accordion-panel__panel_content'>
        <div className='configurator__beam_cutting'>
          <div className='beam_tab_header'>
            <a onClick={(e) => setTab(1)} className={selectedBeamType === 1 ? 'active' : ''}
            >
              {translate('beamtype.cuttingonestreight')}
            </a>
            <a onClick={(e) => setTab(0)} className={selectedBeamType === 0 ? 'active' : ''}
            >
              {translate('beamtype.cuttingoneside')}
            </a>
            <a onClick={(e) => setTab(2)} className={selectedBeamType === 2 ? 'active' : ''}
            >
              {translate('beamtype.cuttingtwoside')}
            </a>
          </div>
          <div className='beam_tab_body beam_tab_body--no-flex'>
            {getAllAnglesItems().length > 0 && (
              <PanelBeamCuttingSvgAlt
                id={id}
                items={getAllAnglesItems()}
                onClick={change}
                cutType={cutType}
                shape={rules.shape}
                articleNumber={erpVariantId}
              />
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default PanelBeam;
